import { render } from "./contact.vue?vue&type=template&id=35ef248b&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=35ef248b&scoped=true&lang=less"

import exportComponent from "/data/opt/jenkins/workspace/prod/建博会大药房/dms-web-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ef248b"]])

export default __exports__